/**
 * CustomerIdentification
 * Provides identity validation based off information submitted for specific customer.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { Customer } from '../model/models';
import { IdentificationResultQuestions } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface CustomerIdentificationServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Verify customer identity and provide challenge questions.
     * Verify Customer
     * @param customer Customer info object
     */
    checkCustomerIndentification(customer: Customer, extraHttpRequestParams?: any): Observable<IdentificationResultQuestions>;

}
